// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__qnbWS","disabled":"button_disabled__YqJ7M","secondary":"button_secondary__fFr3h"};